jQuery(document).ready(function () {
  if ($('.tableaufourstep').length > 0) {

    $('.tableaufourstep_button').on('click', function (e) {
      $(".tableaufourstep_title").removeClass('tableaufourstep_title-active');
      $(e.currentTarget).toggleClass('tableaufourstep_title-active');
      var curtab = $(e.currentTarget).data('tab');
      $('.tableaufourstep_lower').removeClass('tableaufourstep_show');
      $('.tableaufourstep_lower').each(function (i, obj) {
        if ($(this).data('content') == curtab) {
          console.log(curtab);

          if (curtab == 1){
            $("#tableaufourstep_3").removeClass("tableaufourstep_actif");
            $("#tableaufourstep_2").removeClass("tableaufourstep_actif");
            $("#tableaufourstep_4").removeClass("tableaufourstep_actif");
           
          }
          else if (curtab == 2){
            $("#tableaufourstep_3").removeClass("tableaufourstep_actif");
            $("#tableaufourstep_4").removeClass("tableaufourstep_actif");
            $("#tableaufourstep_2").addClass("tableaufourstep_actif");

          }
          else if (curtab == 3) {
            $("#tableaufourstep_4").removeClass("tableaufourstep_actif");
            $("#tableaufourstep_3").addClass("tableaufourstep_actif");
            $("#tableaufourstep_2").addClass("tableaufourstep_actif");
          }
          else {
            $("#tableaufourstep_3").addClass("tableaufourstep_actif");
            $("#tableaufourstep_2").addClass("tableaufourstep_actif");
            $("#tableaufourstep_4").addClass("tableaufourstep_actif");
          }

          $(this).addClass("tableaufourstep_show");
          
        }
      });
    });
    $(".tableaufourstep_select").change(function () {
      var seltab = $(".tableaufourstep_select option:selected").val();
      $('.tableaufourstep_lower').hide();
      $('.tableaufourstep_lower').each(function (i, obj) {
        if ($(this).data('content') == seltab) {
          $(this).show();
        }
      });
    });


  }
});

